var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "maintenance-body",
      class: {
        mobile: _vm.isMobile,
        vertical: _vm.isMobileVertical,
        landscape: _vm.isMobileLandscape,
      },
    },
    [
      _c("section", { staticClass: "container" }, [
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "modal-header-wrapper" }, [_c("Logo")], 1),
          _c("h1", [_vm._v("We'll be back soon!")]),
          _c("p", { staticClass: "subtitle" }, [
            _vm._v("Our system is currently undergoing scheduled maintenance."),
          ]),
          _c("div", { staticClass: "time-section" }, [
            _c("p", [
              _c("strong", [_vm._v("From:")]),
              _vm._v(" " + _vm._s(_vm.maintenance.from)),
            ]),
            _c("p", [
              _c("strong", [_vm._v("To:")]),
              _vm._v(" " + _vm._s(_vm.maintenance.to)),
            ]),
          ]),
          _c(
            "button",
            {
              staticClass: "try-again-button",
              attrs: { disabled: _vm.isLoading },
              on: { click: _vm.debouncedReloadPage },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.isLoading ? "Checking..." : "Try Again") + " "
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }